import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Box, Tabs, TabList, Tab, Select} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const InvoiceStatusTabs = ({tabs, currentTab, setCurrentTab}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Flex>
      <Box display={{base: 'none', lg: 'flex'}}>
        <Tabs
          variant="basic"
          index={tabs.indexOf(currentTab)}
          onChange={(index) => setCurrentTab(tabs[index])}
        >
          <TabList>
            {Object.keys(tabs).map((key) => (
              <Tab
                data-testid={`invoice-status-tab-${tabs[key].toLowerCase()}`}
                key={key}
              >
                {t(`invoices.tabs.${tabs[key]}`)}
              </Tab>
            ))}
          </TabList>
        </Tabs>
      </Box>

      <Box display={{base: 'block', lg: 'none'}}>
        <Select
          value={currentTab}
          onChange={(e) => setCurrentTab(e.target.value)}
          p={2}
          textTransform="uppercase"
          fontWeight={500}
          color="mld.neutral.900"
          border="0px none"
          fontSize="sm"
        >
          {tabs.map((tab) => (
            <option key={tab} value={tab}>
              {t(`invoices.tabs.${tab}`)}
            </option>
          ))}
        </Select>
      </Box>
    </Flex>
  )
}

InvoiceStatusTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentTab: PropTypes.string.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
}

export default InvoiceStatusTabs
